import apiClient from "@/shared/services/api/apiClient.js";
import { HRDashboardData } from "../types";

interface DashboardStatsApiResponse {
  success: boolean;
  message?: string;
  data: HRDashboardData;
}

export const getDashboardStats = async (): Promise<HRDashboardData> => {
  const response = await apiClient.get(
    "/hr/dashboard-stats",
    { showLoader: true } as any
  );

  const body = response.data as DashboardStatsApiResponse;

  if (!body?.success) {
    throw new Error(body?.message || "Failed to fetch HR dashboard statistics");
  }

  return body.data;
};